import { HeaderElementFragment, HeaderLinkFragment } from 'graphql/__generated__/types';
import { getPathName, removeHubNameFromPath } from './common';

export const filterHeaderLinks = (headerNavs: HeaderElementFragment[]) => {
  return headerNavs.filter((nav) => nav.__typename === 'EGDSStandardLink') as HeaderLinkFragment[];
};

export const getActiveTabIndex = (tabId: string, documentId: string, tabs: HeaderLinkFragment[]) => {
  const activeTabIndex = tabs.findIndex((tab) => {
    const tabPath = removeHubNameFromPath(getPathName(tab.action.resource.value));
    return tabPath && documentId && documentId.includes(tabPath);
  });

  return !tabId || activeTabIndex === -1 ? 0 : activeTabIndex;
};
